const React = require("react");
const { useInventorySource } = require("../context/InventorySourceContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;
const DropshippingPlatformDetails = () => {
  const { api, t } = useInventorySource();
  const resource = useResource(async () => ({ ...(await api.getPlatform()), ...(await api.getConnection()) }), [api]);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const action = async (callback, success) => { setBusy(true); setError(""); setMessage(""); try { await callback(); setMessage(success); await resource.reload(); } catch (requestError) { setError(requestError.message); } finally { setBusy(false); } };
  const platform = resource.data?.platform; const connection = resource.data?.connection;
  const details = platform ? h("div", { className: "isds-card" },
    h("div", { className: "isds-card-body" },
      h("div", { className: "isds-row isds-between" },
        h("h3", null, platform.name),
        h(StatusBadge, { status: connection?.status || "not_connected", t })
      ),
      h("p", { className: "isds-muted" }, `${t("h_inventorySource_store", "Store")}: ${connection?.storeName || connection?.externalStoreId || "—"}`),
      h("p", { className: "isds-muted" }, `${t("h_inventorySource_last_sync", "Last synchronization")}: ${connection?.lastSyncAt ? new Date(connection.lastSyncAt).toLocaleString() : "—"}`),
      h("div", { className: "isds-row" },
        h(LinkButton, { to: "/dropshipping/inventory-source/connect" }, t("h_inventorySource_connection", "Connection")),
        connection ? h(Button, { variant: "secondary", disabled: busy, onClick: () => action(api.testConnection, t("h_inventorySource_test_ok", "Connection test passed.")) }, t("h_inventorySource_test", "Test")) : null,
        connection?.status === "active" ? h(Button, { disabled: busy, onClick: () => action(api.syncAll, t("h_inventorySource_sync_ok", "InventorySource synchronization completed.")) }, t("h_inventorySource_sync", "Synchronize")) : null
      )
    )
  ) : null;
  return h(React.Fragment, null,
    h(PageHeader, { title: t("h_inventorySource_details_title", "InventorySource details") }),
    message ? h("div", { className: "isds-success", role: "status" }, message) : null,
    error ? h("div", { className: "isds-alert", role: "alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !platform, reload: resource.reload, t }, details)
  );
};
module.exports = { DropshippingPlatformDetails };
